import script from "./login-trend-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./login-trend-chart.vue?vue&type=script&lang=ts&setup=true"

import "./login-trend-chart.vue?vue&type=style&index=0&id=3888a174&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3888a174"]])

export default __exports__